import { formatGetHeaders } from '@configurations/api-configuration';
import { WeatherYearGateway } from '@scenario/gateways/weather-year.gateway';
import { WeatherYear } from '@scenario/models/weather-year.model';
import { environment } from '../../../../../environments/environment';

export class ApiWeatherYearGateway implements WeatherYearGateway {
  private readonly weatherYearApi = `${environment.backend_url}/api/v1/weatheryear`;

  async retrieveAll(): Promise<WeatherYear[]> {
    try {
      const response = await fetch(`${this.weatherYearApi}`, await formatGetHeaders());
      return await response.json();
    } catch (error) {
      throw new Error('Error retrieving weather years: ' + error);
    }
  }
}
